/* Endro - LP Routine Anti-Âge
   Synchronise le choix du type de peau entre toutes les sections "AA - ..." de la page,
   et gère le bloc d'achat (galerie, prix, ajout panier, barre collante mobile). */
(function () {
  if (window.EAA_INIT) return;
  window.EAA_INIT = true;

  var DEFAULT_SKIN = 'seche';
  var current = null;

  function readSaved() {
    try { return sessionStorage.getItem('eaa-skin'); } catch (e) { return null; }
  }
  function save(skin) {
    try { sessionStorage.setItem('eaa-skin', skin); } catch (e) {}
  }

  /* Affiche ce qui correspond au type de peau choisi, partout sur la page */
  function apply(skin, opts) {
    if (!skin) return;
    current = skin;
    save(skin);

    document.querySelectorAll('[data-eaa-skin]').forEach(function (el) {
      var s = el.getAttribute('data-eaa-skin');
      el.hidden = !(s === 'all' || s === skin);
    });

    document.querySelectorAll('[data-eaa-pick]').forEach(function (btn) {
      var on = btn.getAttribute('data-eaa-pick') === skin;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.classList.toggle('is-selected', on);
    });

    document.querySelectorAll('[data-eaa-routine]').forEach(function (root) {
      var radio = root.querySelector('input[data-eaa-option-skin="' + skin + '"]');
      if (radio && !radio.disabled) radio.checked = true;
      refreshRoutine(root);
    });

    if (!(opts && opts.silent)) {
      document.dispatchEvent(new CustomEvent('eaa:skin', { detail: { skin: skin } }));
    }
  }

  /* --- Bloc d'achat --- */
  function selectedRadio(root) {
    return root.querySelector('input[type="radio"]:checked');
  }

  function refreshRoutine(root) {
    var r = selectedRadio(root);
    if (!r) return;
    var d = r.dataset;
    var set = function (sel, val) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
    };
    set('[data-eaa-price]', d.price);
    set('[data-eaa-compare]', d.compare || '');
    set('[data-eaa-saving]', d.saving || '');
    set('[data-eaa-pct]', d.pct || '');
    set('[data-eaa-name]', d.title);
    root.querySelectorAll('[data-eaa-if-discount]').forEach(function (el) {
      el.hidden = !d.compare;
    });
    var submit = root.querySelector('[data-eaa-submit]');
    if (submit) submit.disabled = false;
  }

  function initRoutine(root) {
    if (root.dataset.eaaReady) return;
    root.dataset.eaaReady = '1';

    var form = root.querySelector('[data-eaa-form]');
    var submit = root.querySelector('[data-eaa-submit]');
    var errorEl = root.querySelector('[data-eaa-error]');
    var after = root.getAttribute('data-eaa-after') || 'cart';
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    // Choisir une routine dans le bloc d'achat change aussi le type de peau de la page
    form.addEventListener('change', function (e) {
      var skin = e.target && e.target.getAttribute('data-eaa-option-skin');
      if (skin) apply(skin); else refreshRoutine(root);
    });

    // Galeries (une par routine)
    root.querySelectorAll('[data-eaa-gallery]').forEach(function (g) {
      var main = g.querySelector('.eaa-main-img');
      g.querySelectorAll('[data-eaa-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = btn.getAttribute('data-eaa-thumb'); }
          g.querySelectorAll('[data-eaa-thumb]').forEach(function (b) {
            b.setAttribute('aria-current', b === btn ? 'true' : 'false');
          });
        });
      });
    });

    // Ajout au panier
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = selectedRadio(root);
      if (!r) return;
      submit.disabled = true;
      errorEl.hidden = true;
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] })
      })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw d; return d; }); })
        .then(function () { window.location.href = base + (after === 'checkout' ? 'checkout' : 'cart'); })
        .catch(function (err) {
          errorEl.textContent = (err && err.description) || "L'ajout au panier n'a pas fonctionné. Merci de réessayer.";
          errorEl.hidden = false;
          submit.disabled = false;
        });
    });

    // Barre d'achat collante (mobile)
    var sticky = root.querySelector('[data-eaa-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var formVisible = false;
      var update = function () {
        var show = !formVisible && window.scrollY > 600;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.inert = !show;
      };
      sticky.inert = true;
      new IntersectionObserver(function (entries) {
        formVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(form);
      window.addEventListener('scroll', update, { passive: true });
    }

    refreshRoutine(root);
  }

  /* --- Cartes "Comment est votre peau ?" --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-eaa-pick]');
    if (!btn) return;
    apply(btn.getAttribute('data-eaa-pick'));
    var next = btn.getAttribute('data-eaa-scroll');
    if (next) {
      var target = document.querySelector(next);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  function init() {
    document.querySelectorAll('[data-eaa-routine]').forEach(initRoutine);
    var pageDefault = document.querySelector('[data-eaa-default-skin]');
    var start = readSaved() || (pageDefault && pageDefault.getAttribute('data-eaa-default-skin')) || DEFAULT_SKIN;
    apply(start, { silent: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Éditeur de thème : réappliquer quand une section est rechargée
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-eaa-routine]').forEach(initRoutine);
    apply(current || DEFAULT_SKIN, { silent: true });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-eaa-skin]');
    if (el) {
      var s = el.getAttribute('data-eaa-skin');
      if (s && s !== 'all') apply(s, { silent: true });
    }
  });
})();
